<template>
  <div id="cardContentRayonX">
    <div class="cardContentRayonX_title">
      L’optimiseur de plateforme
    </div>
    <div class="mt-3">
      <div>
        Vos frais liés à votre banque :
      </div>
      <div>Total de <span class="txt_purple">{{ Number(platform_total_fees).toFixed(0) }}€ / an</span></div>
    </div>
    <div class="mt-3" v-if="average_platform_fees != 0">
      Vous faites mieux que <span class="txt_purple">{{getUserRanking()}} %</span> de nos utilisateurs
      <mf_star_rating
        :star="this.starNum"
        starsize="2x"
      />
    </div>
    <div class="mt-3">
      <div>
        Economie potentielle : <span class="txt_purple">{{ Number(saving_platform_management_overall).toFixed(0) }}€ / an</span>
      </div>
      <div>
        Soit un gain de <span class="txt_purple">{{ formatEuros(saving_platform_management_overall * 25) }}€ sur 25 ans</span>
      </div>
    </div>
    <div class="mt-3">
      <b-button href="/scan/comparison/platforms" class="btnCardContent">
        Analyser mes frais de plateforme
      </b-button>
    </div>
  </div>
</template>
<script>
export default {
  props: ["average_platform_fees_user", "average_platform_fees", "total_savings", "saving_platform_management_overall","platform_total_fees"],
  data() {
    return {
      starNum: 0
    };
  },
  methods: {
    getUserRanking()
    {
      let percentage = Number(this.average_platform_fees_user / this.average_platform_fees).toFixed(2);
      this.starNum = Math.round(percentage*5/100);
      console.log(this.starNum);
      return this.$utils.numberWithSpaces(percentage);
    },
    formatEuros(number)
    {
      return this.$utils.numberWithSpaces(Number(number).toFixed(0));
    },
  }
};
</script>
<style lang="scss">
#cardContentRayonX {
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: space-around;
}
</style>
